import { API_BASE } from '../config';

// Route a GCS asset (image or video) through the API proxy so WebGL can sample
// it — textures and VideoTextures are CORS-gated and the GCS buckets don't send
// Access-Control-Allow-Origin. Handles gs:// and signed storage.googleapis.com
// URLs (the signature query is dropped; the proxy re-signs by bucket+name).
// Anything else passes through untouched.
export function proxied(url) {
  if (!url) return url;
  try {
    if (url.startsWith('gs://')) {
      const rest = url.slice(5);
      const i = rest.indexOf('/');
      return `${API_BASE}/api/assets/file?bucket=${encodeURIComponent(rest.slice(0, i))}&name=${encodeURIComponent(rest.slice(i + 1))}`;
    }
    const u = new URL(url);
    if (u.hostname === 'storage.googleapis.com') {
      const parts = u.pathname.replace(/^\//, '').split('/');
      const bucket = parts.shift();
      const name = parts.map(decodeURIComponent).join('/');
      return `${API_BASE}/api/assets/file?bucket=${encodeURIComponent(bucket)}&name=${encodeURIComponent(name)}`;
    }
  } catch { /* passthrough */ }
  return url;
}
